<template>
    <div class="__profile b-white p-1 bh-cursor border-bottom" @click="goProfile">
        <div class="__content d-flex align-items-center" @click="changeStatus">
            <b-spinner v-if="status == 'send'" small label="Nuevo Candidato" type="grow" class="font-gray-dark"></b-spinner>
            <b-spinner v-if="status == 'aproved'" small label="Nuevo Candidato" type="grow" class="font-green"></b-spinner>
            <img class="rounded-circle" v-if="avatar == 'avatar.png' || avatar == undefined || avatar == null " src="@/assets/profile/user_empty.png" alt="" width="30" height="30">
            <img class="rounded-circle" v-else :src="avatar" alt="" width="30" height="30">
            <div class="_name ml-2" :class="status == 'aproved' ? 'font-green' : ''" >
                {{name}}
                <br>
                <small class="font-gray-dark">Presiona para ver información de candidato</small>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CandidateTarget',
    props:{
        unique: Number,
        id: Number,
        name: String,
        avatar: String,
        status: String,
    },
    data() {
        return {
            job_id: this.$route.params.idjob,
        }
    },
    methods:{
        goProfile(){
            this.$parent.viewCandidate(this.id)
        },
        changeStatus(){
            if(this.status == 'send'){
                this.api.get('enterprise/job/candidate/' + this.job_id + '/options/' + this.id + '/tool/read').then(({data}) => {
                    this.$parent.changeStatusList(this.unique, 'read') 
                }).catch(err => {})
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/#pages/jobs/components/CandidateTarget.vue